import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/nnpp/components')({
  component: Outlet,
})
